var render, staticRenderFns
import script from "./tp-table.vue?vue&type=script&lang=js"
export * from "./tp-table.vue?vue&type=script&lang=js"
import style0 from "./tp-table.vue?vue&type=style&index=0&id=576e53e8&prod&lang=scss&scoped=true"
import style1 from "./tp-table.vue?vue&type=style&index=1&id=576e53e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e53e8",
  null
  
)

export default component.exports